import React from 'react'
import './Header.css'

const Header = () => {
	const scroll = () => {
		const contact = document.getElementById('contact')
		if (contact) contact.scrollIntoView({ behavior: 'smooth' })
	}

	return (
    <header className="hero">
      <div className="hero-bg" aria-hidden="true">
        <img src="/assets/images/motorcycle-bg.jpg" alt="" />
        <div className="hero-overlay"></div>
        <div className="hero-grid"></div>
      </div>

      <nav className="hero-nav">
        <div className="brand">
          <div className="brand-logo-wrap">
            <img
              src="/new-logo-motorcycle.png"
              alt="GW Motorsports LLC Motorcycle Shop Logo"
              className="brand-logo"
            />
          </div>
          <div className="brand-text">
            <span className="brand-name">GW Motorsports</span>
            <span className="brand-sub">LLC · Motorcycle Shop</span>
          </div>
        </div>
        <button className="nav-cta" onClick={scroll}>
          Contact
        </button>
      </nav>

      <div className="hero-content">
        <span className="hero-eyebrow">Waxahachie, TX · Established 2018</span>
        <div className="hero-headline">
          <div className="hero-logo-mark" aria-hidden="true">
            <img
              src="/new-logo-motorcycle.png"
              alt=""
              className="hero-logo-img"
            />
          </div>
          <h1 className="hero-title">
            GW <span className="accent">Motorsports</span> LLC
          </h1>
        </div>
        <p className="hero-sub">
          Performance motorcycle shop for service, parts installation, and
          tuning. Quality and attention to detail on every bike that leaves our
          shop.
        </p>
        <div className="hero-actions">
          <button className="btn-primary" onClick={scroll}>
            Get a Consultation
          </button>
          <a href="tel:9452862506" className="btn-ghost">
            <span className="dot"></span>
            (945) 286-2506
          </a>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <span className="stat-number">7+</span>
            <span className="stat-label">Years Serving DFW</span>
          </div>
          <div className="stat">
            <span className="stat-number">4</span>
            <span className="stat-label">Full Service Bays</span>
          </div>
          <div className="stat">
            <span className="stat-number">2,200</span>
            <span className="stat-label">HP Dyno Capability</span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header
